var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_2298_18956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33325 4.16659C3.33325 4.3876 3.42105 4.59956 3.57733 4.75584C3.73361 4.91212 3.94557 4.99992 4.16659 4.99992C4.3876 4.99992 4.59956 4.91212 4.75584 4.75584C4.91212 4.59956 4.99992 4.3876 4.99992 4.16659C4.99992 3.94557 4.91212 3.73361 4.75584 3.57733C4.59956 3.42105 4.3876 3.33325 4.16659 3.33325C3.94557 3.33325 3.73361 3.42105 3.57733 3.57733C3.42105 3.73361 3.33325 3.94557 3.33325 4.16659Z",
    fill: "#909090",
    stroke: "#909090",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.16675 4.16659C9.16675 4.3876 9.25455 4.59956 9.41083 4.75584C9.56711 4.91212 9.77907 4.99992 10.0001 4.99992C10.2211 4.99992 10.4331 4.91212 10.5893 4.75584C10.7456 4.59956 10.8334 4.3876 10.8334 4.16659C10.8334 3.94557 10.7456 3.73361 10.5893 3.57733C10.4331 3.42105 10.2211 3.33325 10.0001 3.33325C9.77907 3.33325 9.56711 3.42105 9.41083 3.57733C9.25455 3.73361 9.16675 3.94557 9.16675 4.16659Z",
    fill: "#909090",
    stroke: "#909090",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15 4.16659C15 4.3876 15.0878 4.59956 15.2441 4.75584C15.4004 4.91212 15.6123 4.99992 15.8333 4.99992C16.0543 4.99992 16.2663 4.91212 16.4226 4.75584C16.5789 4.59956 16.6667 4.3876 16.6667 4.16659C16.6667 3.94557 16.5789 3.73361 16.4226 3.57733C16.2663 3.42105 16.0543 3.33325 15.8333 3.33325C15.6123 3.33325 15.4004 3.42105 15.2441 3.57733C15.0878 3.73361 15 3.94557 15 4.16659Z",
    fill: "#909090",
    stroke: "#909090",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.33325 10.0001C3.33325 10.2211 3.42105 10.4331 3.57733 10.5893C3.73361 10.7456 3.94557 10.8334 4.16659 10.8334C4.3876 10.8334 4.59956 10.7456 4.75584 10.5893C4.91212 10.4331 4.99992 10.2211 4.99992 10.0001C4.99992 9.77907 4.91212 9.56711 4.75584 9.41083C4.59956 9.25455 4.3876 9.16675 4.16659 9.16675C3.94557 9.16675 3.73361 9.25455 3.57733 9.41083C3.42105 9.56711 3.33325 9.77907 3.33325 10.0001Z",
    fill: "#909090",
    stroke: "#909090",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.16675 10.0001C9.16675 10.2211 9.25455 10.4331 9.41083 10.5893C9.56711 10.7456 9.77907 10.8334 10.0001 10.8334C10.2211 10.8334 10.4331 10.7456 10.5893 10.5893C10.7456 10.4331 10.8334 10.2211 10.8334 10.0001C10.8334 9.77907 10.7456 9.56711 10.5893 9.41083C10.4331 9.25455 10.2211 9.16675 10.0001 9.16675C9.77907 9.16675 9.56711 9.25455 9.41083 9.41083C9.25455 9.56711 9.16675 9.77907 9.16675 10.0001Z",
    fill: "#909090",
    stroke: "#909090",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15 10.0001C15 10.2211 15.0878 10.4331 15.2441 10.5893C15.4004 10.7456 15.6123 10.8334 15.8333 10.8334C16.0543 10.8334 16.2663 10.7456 16.4226 10.5893C16.5789 10.4331 16.6667 10.2211 16.6667 10.0001C16.6667 9.77907 16.5789 9.56711 16.4226 9.41083C16.2663 9.25455 16.0543 9.16675 15.8333 9.16675C15.6123 9.16675 15.4004 9.25455 15.2441 9.41083C15.0878 9.56711 15 9.77907 15 10.0001Z",
    fill: "#909090",
    stroke: "#909090",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M3.33325 15.8333C3.33325 16.0543 3.42105 16.2663 3.57733 16.4226C3.73361 16.5789 3.94557 16.6667 4.16659 16.6667C4.3876 16.6667 4.59956 16.5789 4.75584 16.4226C4.91212 16.2663 4.99992 16.0543 4.99992 15.8333C4.99992 15.6123 4.91212 15.4004 4.75584 15.2441C4.59956 15.0878 4.3876 15 4.16659 15C3.94557 15 3.73361 15.0878 3.57733 15.2441C3.42105 15.4004 3.33325 15.6123 3.33325 15.8333Z",
    fill: "#909090",
    stroke: "#909090",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M9.16675 15.8333C9.16675 16.0543 9.25455 16.2663 9.41083 16.4226C9.56711 16.5789 9.77907 16.6667 10.0001 16.6667C10.2211 16.6667 10.4331 16.5789 10.5893 16.4226C10.7456 16.2663 10.8334 16.0543 10.8334 15.8333C10.8334 15.6123 10.7456 15.4004 10.5893 15.2441C10.4331 15.0878 10.2211 15 10.0001 15C9.77907 15 9.56711 15.0878 9.41083 15.2441C9.25455 15.4004 9.16675 15.6123 9.16675 15.8333Z",
    fill: "#909090",
    stroke: "#909090",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15 15.8333C15 16.0543 15.0878 16.2663 15.2441 16.4226C15.4004 16.5789 15.6123 16.6667 15.8333 16.6667C16.0543 16.6667 16.2663 16.5789 16.4226 16.4226C16.5789 16.2663 16.6667 16.0543 16.6667 15.8333C16.6667 15.6123 16.5789 15.4004 16.4226 15.2441C16.2663 15.0878 16.0543 15 15.8333 15C15.6123 15 15.4004 15.0878 15.2441 15.2441C15.0878 15.4004 15 15.6123 15 15.8333Z",
    fill: "#909090",
    stroke: "#909090",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2298_18956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.6aea7a7e732ef705b5c3999bd764da57.svg";
export { ForwardRef as ReactComponent };